import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function RosterShare() {
  const scheduleId = useParams().scheduleId;

  // 더미 데이터 (엔드포인트 준비되면 실제 API로 교체)
  const getDummyScheduleData = () => {
    if (!scheduleId) return null;

    // scheduleId에서 연도와 월 추출 시도 (예: "2026-08" 또는 "202608")
    // 없으면 현재 날짜 기준으로 더미 데이터 생성
    const today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;

    // scheduleId 형식에 따라 파싱 시도
    if (scheduleId.includes("-")) {
      const parts = scheduleId.split("-");
      if (parts.length >= 2) {
        year = parseInt(parts[0]) || year;
        month = parseInt(parts[1]) || month;
      }
    } else if (scheduleId.length >= 6) {
      // "202608" 형식
      year = parseInt(scheduleId.substring(0, 4)) || year;
      month = parseInt(scheduleId.substring(4, 6)) || month;
    }

    return { year, month };
  };

  const scheduleData = getDummyScheduleData();

  // title과 description 동적 생성
  const title = scheduleData
    ? `Aide 온마음: ${scheduleData.year}년 ${scheduleData.month}월 AI 근무표`
    : "Aide 온마음: AI 근무표";

  const description = scheduleData
    ? `${scheduleData.year}년 ${scheduleData.month}월 근무표를 확인하세요`
    : "모든 마음을 모아, 마음을 ON 하다. 함께 마음을 모아 더 좋은 근무환경을 만들어가자는 의미를 가지고 있습니다.";

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/asset/meta/metaImg.png" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/asset/meta/metaImg.png" />
      </Helmet>
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">근무표 공유</h1>
          <p className="text-gray-600">scheduleId: {scheduleId}</p>
        </div>
      </div>
    </>
  );
}
